import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox'
import { twMerge } from 'tailwind-merge'
import { choiceControlClasses } from '../../lib/choice-control'
import { useFieldRequired } from '../field/nested/context'
import { CheckboxIndicator } from './nested/indicator'
import { CheckboxGroup } from './nested/group'
import type { PartProps } from '../../lib/part-props'

interface CheckboxRootProps extends PartProps<BaseCheckbox.Root.Props> {
  className?: string
}

/** A choice collected now and acted on later. Use a Toggle when flipping it applies the setting. */
function Checkbox({ className, children, required, ...props }: CheckboxRootProps) {
  return (
    <BaseCheckbox.Root
      required={useFieldRequired(required)}
      className={twMerge(
        choiceControlClasses,
        'group/checkbox corner-squircle inline-grid place-items-center rounded',
        className,
      )}
      {...props}
    >
      {children}
    </BaseCheckbox.Root>
  )
}

Checkbox.Indicator = CheckboxIndicator
Checkbox.Group = CheckboxGroup

export { Checkbox }
